import adminApiClient from './apiClient.js';

export const assinaturasApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/assinaturas/', { params });
    return data;
  },
  get: async (id) => {
    const { data } = await adminApiClient.get(`/assinaturas/${id}`);
    return data;
  },
  cancel: async (id, motivo) => {
    const { data } = await adminApiClient.post(`/assinaturas/${id}/cancel`, { motivo });
    return data;
  },
  resumo: async () => {
    const { data } = await adminApiClient.get('/assinaturas/resumo');
    return data;
  },
  insightsDiario: async (dias = 30) => {
    const { data } = await adminApiClient.get('/assinaturas/insights/diario', { params: { dias } });
    return data;
  },
};

export default assinaturasApi;
